// Module
var code = `<miscellaneous-transactions-page header-title="\$ctrl.header" form-title="\$ctrl.header | uppercase">
  <h2 class="section-header">Please confirm the following:</h2>
  <form name="\$ctrl.transactionForm">
    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
        <tr ng-if="\$ctrl.interbranch">
          <td></td>
          <td>Target branch:</td>
          <td>
            <selectize
              options="\$ctrl.allowedBranches"
              ng-model="\$ctrl.transaction.targetBranchId"
              config="\$ctrl.targetBranchSelectConfig"
              class="nx-selectize"
              ng-change="\$ctrl.updateDepositoryAccounts()"
              required
          ></selectize>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Depository bank account:</td>
          <td>
            <selectize options="\$ctrl.depositoryAccounts"
                       config="\$ctrl.selectConfig"
                       ng-model="\$ctrl.transaction.depositoryAccountId"
                       required>
            </selectize>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Amount to {{ \$ctrl.viewContext.type | lowercase }}:</td>
          <td>
            <cash ng-model="\$ctrl.transaction.amount"
                  ng-required="true"
                  min="0.01">
            </cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Remarks:</td>
          <td>
            <input type="text"
                   ng-model="\$ctrl.transaction.remarks"
                   maxlength="512">
          </td>
        </tr>
      </tbody>
    </table>
    <div class="summary-actions">
      <button
        type="button"
        class="btn btn-warning"
        ng-click="\$ctrl.cancel()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn {{ \$ctrl.viewContext.actionBtnClass }}"
        ng-disabled="\$ctrl.transactionForm.\$invalid"
        ng-click="\$ctrl.save()">
        {{ \$ctrl.viewContext.type }}
      </button>
    </div>
  </form>
</miscellaneous-transactions-page>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/cash-to-from-bank/cash-to-from-bank.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;